<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'button',
  },

  text: {
    type: String,
    required: true,
  },

  loading: {
    type: Boolean,
  },

  disabled: {
    type: Boolean,
  },
});

const emit = defineEmits(['click']);

function onButtonClick(event) {
  emit('click', event);
}
</script>

<template>
  <button
    :disabled="props.disabled || props.loading"
    class="ui-button-main"
    :type="props.type"
    @click="onButtonClick"
  >
    <transition name="fade">
      <span class="ui-button-main__font ui-button-main__font--text">
        {{ props.text }}
      </span>
    </transition>
  </button>
</template>

<style lang="scss" scoped>
.ui-button-main {
  $parent: &;

  padding: em(11) em(20) em(12);
  color: $color-white;
  text-transform: uppercase;
  background-color: $accent-red;
  border: none;
  border-radius: em(10);
  transition: background-color $time-fast ease-out;

  &:disabled {
    #{$parent} {
      &__font {
        opacity: 0.7;
      }
    }
  }

  @include hover-active-focus {
    background-color: $accent-red-hover;
  }

  @include media-breakpoint-down(md) {
    padding: em(8) em(16) em(9);
  }

  @include media-breakpoint-down(sm) {
    padding: em(7) em(16) em(8);
    border-radius: em(6);
  }

  &__font {
    &--text {
      font-size: em(14);
      font-weight: 800;
      line-height: 100%;

      @include media-breakpoint-down(md) {
        font-size: em(11);
      }
    }
  }
}
</style>
